import React, { useState, useEffect } from "react";
import "./Banner.css";
import data from "./Data";
import { AiOutlineFastForward, AiOutlineFastBackward } from "react-icons/ai";

const Slider = () => {
  const [people] = useState(data);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const lastIndex = people.length - 1;
    if (index < 0) {
      setIndex(lastIndex);
    }
    if (index > lastIndex) {
      setIndex(0);
    }
  }, [index, people]);

  useEffect(() => {
    let slider = setInterval(() => {
      setIndex(index + 1);
    }, 5000);
    return () => {
      clearInterval(slider);
    };
  }, [index]);

  return (
    <section className="section">
      <div className="section-center">
        {people.map((item, indexPeople) => {
          const { id, url, quote1, quote2 } = item;
          let position = "nextSlide";
          if (indexPeople === index) {
            position = "activeSlide";
          }
          if (
            indexPeople === index - 1 ||
            (index === 0 && indexPeople === people.length - 1)
          ) {
            position = "lastSlide";
          }
          return (
            <article className={position} key={id}>
              <img src={url} className="bg-image" />
              <div className="banner_container">
                <p className="text">{quote1}</p>
                <p className="quote2">{quote2}</p>
              </div>
             
            </article>
          );
        })}
       
        <button className="prev" onClick={() => setIndex(index - 1)}>
          <AiOutlineFastBackward />
        </button>
        <button className="next" onClick={() => setIndex(index + 1)}>
          <AiOutlineFastForward />
        </button>
      </div>
    </section>
  );
};

export default Slider;
